import React, { useContext } from 'react'
import { FaAngleUp, FaAngleDown } from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
// import TimeWindowSelectorButton from '../../../elem/chart/TimeWindowSelectorButton'
import AnalyteSelectorButton from '../../../elem/chart/AnalyteSelectorButton'
// import ResetZoomButton from '../../../elem/chart/ResetZoomButton'
import ResetDropDownButton from '../../../elem/chart/ResetDropDownButton'

export default () => {
    const {
        // timeWindow,
        // displayTimeWindowDropdown,
        // toggleTimeWindowDropdown,
        displayAnalyteWindowDropdown,
        toggleAnalyteWindowDropdown,
        analyteList,
        // resetZoom,
        setCollapsed,
        isCollapsed,
        resetExpanded, 
        toggleResetExpanded,
    } = useContext(DataContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Aggregate Analyte Chart</div>
            <div className="panelButtons">
                <ResetDropDownButton 
                    resetExpanded={resetExpanded} 
                    toggleResetExpanded={toggleResetExpanded}
                />
                {/* <ResetZoomButton resetFunction={resetZoom} /> */}
                {analyteList && analyteList.length ? (
                    <AnalyteSelectorButton
                        displayAnalyteWindowDropdown={
                            displayAnalyteWindowDropdown
                        }
                        toggleAnalyteWindowDropdown={
                            toggleAnalyteWindowDropdown
                        }
                    />
                ) : null}
                {/* <TimeWindowSelectorButton
                    timeWindow={timeWindow}
                    displayTimeWindowDropdown={displayTimeWindowDropdown}
                    toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                /> */}
                <div className="panelHeaderIconWrapper">
                    <div
                        className="panelHeaderIconDiv"
                        data-tip={`${
                            isCollapsed
                                ? `Expand Aggregate`
                                : `Hide Aggregate`
                        }`}
                        data-for={`aggregate-panel-toggle`}
                        onClick={() =>
                            setCollapsed(!isCollapsed)
                        }
                    >
                        {isCollapsed ? (
                            <FaAngleUp />
                        ) : (
                            <FaAngleDown />
                        )}        
                    </div>
                </div> 
            </div>
        </PanelHeader>
    )
}
